import { render, staticRenderFns } from "./system-settings.vue?vue&type=template&id=d791cdc6"
import script from "./system-settings.vue?vue&type=script&lang=js"
export * from "./system-settings.vue?vue&type=script&lang=js"
import style0 from "./system-settings.vue?vue&type=style&index=0&id=d791cdc6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports